import React, { useEffect, useState } from 'react';
import { VideoSectionContainer, VideoWithGif } from './styled';
import { images } from '../../Constants/ImageUrls';
import Cookies from 'js-cookie';
import { isDesktopUser } from '../../Utils/ProductUtils';

const VideoSection = (props) => {
  const {
    productId,
    data,
    heading,
    sectionId,
    generalItem,
    lactoMama,
    isFullScreenVideoEnabled,
    setIsFullScreenVideoEnabled,
    removeBottomMargin,
    setShowFullScreenVideo,
    setCurrentVideoIndex,
    stretchMarks,
    tabThemeColor,
  } = props;
  const [playVideo, setplayVideo] = useState(null);
  const [showIcon, setShowIcon] = useState(null);
  const [videoData, setVideoData] = useState([]);

  const openFullScreen = (index) => {
    if (!isDesktopUser()) {
      setShowFullScreenVideo(true);
      setIsFullScreenVideoEnabled?.(true);
      setCurrentVideoIndex(index);
    }
  };

  useEffect(() => {
    for (let i = 0; i < data.length; i++) {
      const video = document.getElementById(sectionId + i);
      if (video) {
        const options = {
          root: null, // use the viewport
          rootMargin: '0px',
          threshold: 0.8, // 50% of the video is visible
        };

        const handleIntersection = (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !isFullScreenVideoEnabled) {
              video.play(); // Autoplay when in viewport
            } else {
              video.pause(); // Pause when out of viewport
            }
          });
        };

        const observer = new IntersectionObserver(handleIntersection, options);
        observer.observe(video);
      }
    }
  }, [isFullScreenVideoEnabled, playVideo]);

  useEffect(() => {
    const zone = Cookies.get('zone');
    const videos = zone
      ? [
          ...data.filter((obj) => obj.regionEligible == zone),
          ...data.filter((obj) => obj.regionEligible == 'All'),
        ]
      : data.filter((obj) => obj.regionEligible == 'All');
    setVideoData(videos);
  }, [Cookies.get('zone')]);

  return (
    <VideoSectionContainer
      lactoMama={lactoMama}
      removeBottomMargin={removeBottomMargin}
      stretchMarks={stretchMarks}
      tabThemeColor={tabThemeColor}
    >
      {generalItem?.sectionBgImage ? (
        <img className="headerImage" src={generalItem?.sectionBgImage} alt="" />
      ) : (
        <h3>{generalItem?.heading}</h3>
      )}
      <div className="flex">
        {videoData?.map((item, index) => {
          return (
            <div
              className="flexItem"
              key={'videoWithGif' + index}
              style={{
                marginRight: index == videoData.length - 1 ? '12px' : '0px',
              }}
            >
              <VideoWithGif>
                <video
                  id={sectionId + index}
                  playsInline
                  autoPlay
                  muted={playVideo != index}
                  loop
                  onClick={() => openFullScreen(index)}
                >
                  <source src={item.url || item.videoUrl} />
                </video>
                {(item.viewCount || item.views) && (
                  <div className="bottomOverlay">
                    <div className="viewCount">
                      <img
                        src="https://images.myloapp.in/NestJsUploads/1720595560968-View-count.webp"
                        alt=""
                      />
                      {item.viewCount || item.views}
                    </div>
                  </div>
                )}

                {isDesktopUser() && (
                  <div
                    onClick={() => {
                      if (playVideo != index) setplayVideo(index);
                      else setplayVideo(null);
                      setShowIcon(index);
                      setTimeout(() => {
                        setShowIcon(null);
                      }, 2000);
                    }}
                    className="soundIconContainer"
                  >
                    <img
                      src={
                        playVideo != index
                          ? 'https://images.myloapp.in/NestJsUploads/1720528923685-Mute.webp'
                          : 'https://images.myloapp.in/NestJsUploads/1720528923683-sound-on.webp'
                      }
                      alt=""
                      className={` soundIcon ${
                        showIcon == index ? 'sound' : 'noOpacity'
                      }
                                        `}
                    />
                  </div>
                )}
              </VideoWithGif>
              {item?.showInstaIcon ? (
                <div className="userProfile">
                  <img src={images.instaIcon} width={18} height={18} alt="" />

                  <div className="caption">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.title,
                      }}
                      style={{ fontSize: '12px' }}
                    ></div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.caption,
                      }}
                      style={{
                        fontSize: '12px',
                        marginTop: '3px',
                      }}
                    ></div>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.caption2,
                      }}
                      style={{
                        fontSize: '12px',
                        marginTop: '3px',
                      }}
                    ></div>
                  </div>
                </div>
              ) : (
                item?.caption && <p className="caption">{item.caption}</p>
              )}
            </div>
          );
        })}
      </div>
      {generalItem?.generalItemBgImage ? (
        <img
          className="headerImage"
          src={generalItem?.generalItemBgImage}
          alt=""
        />
      ) : null}
    </VideoSectionContainer>
  );
};

export default VideoSection;
